import MainLoader from "./MainLoader";

export { MainLoader as Loader };
export default MainLoader;
